import React from "react";
import { Box } from "@mui/material";
import SmartHealthReportSection from "./SmartHealthReportSection";
import VizAppSection from "./VizAppSection";
import AddOnFeaturesSection from "./AddOnFeaturesSection";

/**
 * Products Grid Section
 * 
 * Layout with 3 content cards stacked vertically
 */
const ProductsGridSection = () => {

  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "60px 16px",
          sm: "80px 24px",
          md: "100px 48px",
        },
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* 3 Content Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "24px", md: "32px", lg: "40px" },
          }}
        >
          {/* Smart Health Report Card */}
          <Box>
            <SmartHealthReportSection />
          </Box>

          {/* Viz App Card */}
          <Box>
            <VizAppSection />
          </Box>

          {/* Add On Features Card */}
          <Box>
            <AddOnFeaturesSection />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductsGridSection;

